import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SafeHtmlContainer from "../../../helpers/SafeHtmlContainer";
import {FaSolidIcon} from "../../FontAwesomeIcons";

export function ServiceSearchResult({service, ...props}) {

    const prezzoBase = parseFloat(service.prezzo);
    const percSconto = parseFloat(service.perc_sconto)
    const prezzoScontato = prezzoBase - (prezzoBase * percSconto / 100);
    const categoryPath = Array.isArray(props.categoryPath) ? props.categoryPath : [];

    const handleToggle = () => {
        if (props.onChange) {
            props.onChange(service.id_servizio, !props.selected);
        }
    };

    return (
        <React.Fragment>
            <div
                className={"card p-3 shadow-sm mb-2 cursor-pointer"}
                onClick={handleToggle}
            >
                <b>{props.selected && <FaSolidIcon name={"check-square"} className={"text-primary mr-1"}/>}<SafeHtmlContainer html={service.nome}/></b>
                {
                    !!categoryPath.length &&
                    <div className={"small text-muted mt-1"}>
                        <b>Categoria:</b> {categoryPath.map((category, index) => (
                            <Fragment key={category.id_categoria || index}>
                                {index !== 0 && <span className={"mx-1"}>&gt;</span>}
                                <SafeHtmlContainer html={category.nome}/>
                            </Fragment>
                        ))}
                    </div>
                }
                <div>
                    {
                        !props.showPrices ? '' :
                            <Fragment>
                                <span className={"badge badge-primary mr-1 text-on-bg-primary"}>
                                     {`€${prezzoScontato.toFixed(2)}`}
                                </span>
                                {
                                    !!percSconto &&
                                    <Fragment>
                                        <small className={"mr-1 text-muted text-line-through"}>
                                            {`€${prezzoBase.toFixed(2)}`}
                                        </small>
                                        <span className={"badge badge-success mr-1"}>
                                            Sconto {percSconto}%
                                        </span>
                                    </Fragment>
                                }
                            </Fragment>
                    }
                    {
                        !props.showDuration ? '' :
                            <small
                                className={"mr-1 text-on-bg-main text-nowrap"}>Durata: {service.durata * 5}min </small>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}

ServiceSearchResult.propTypes = {
    service: PropTypes.shape({
        id_servizio: PropTypes.any,
        nome: PropTypes.string,
        descrizione: PropTypes.string,
        immagine: PropTypes.string,
        prezzo: PropTypes.number,
        perc_sconto: PropTypes.number,
        durata: PropTypes.number,
    }),
    selected: PropTypes.bool,
    showPrices: PropTypes.bool,
    showDescription: PropTypes.bool,
    showDuration: PropTypes.bool,
    showImage: PropTypes.bool,
    onChange: PropTypes.func,
    categoryPath: PropTypes.arrayOf(PropTypes.shape({
        id_categoria: PropTypes.any,
        nome: PropTypes.string,
    })),
}
